// extracted by mini-css-extract-plugin
export default {"wrapper":"Od_rA"};